<template>
    <v-dialog :persistent="isExporting" v-model="isOpenDialog" width="1400">
        <v-card>
            <v-card-title class="d-flex">
                <v-row dense>
                    <v-col cols="12" md="5">
                        <div
                            v-if="$vuetify.breakpoint.smAndDown"
                            class="primary--text text-overline ml-2 text-center"
                        >
                            {{ title }}
                        </div>
                        <div
                            v-else
                            class="font-weight-light primary--text text-h4 ml-2"
                        >
                            <v-icon large left> mdi-database-edit </v-icon>
                            {{ title }}
                        </div>
                    </v-col>
                    <v-col cols="12" md="7">
                        <div
                            :class="
                                $vuetify.breakpoint.smAndDown
                                    ? 'd-flex justify-center'
                                    : 'd-flex justify-end'
                            "
                        >
                            <div class="mr-2">
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-if="datePicker"
                                            small
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            dark
                                            outlined
                                            color="green darken-3"
                                            v-on="on"
                                        >
                                            {{
                                                $vuetify.breakpoint.smAndDown
                                                    ? ''
                                                    : 'Fecha Seleccionada: ' +
                                                      date.toString()
                                            }}
                                            <v-icon rigth>mdi-calendar</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-date-picker
                                        color="green darken-3"
                                        v-model="date"
                                        type="month"
                                        no-title
                                        scrollable
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            depressed
                                            text
                                            color="primary"
                                            @click="$refs.menu.save(date)"
                                        >
                                            Guardar
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="red"
                                            @click="menu = false"
                                        >
                                            Cerrar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </div>
                            <div class="mr-2" v-if="templateMutationPath != ''">
                                <v-btn
                                    @click="download_template"
                                    class="vcard-text-sm"
                                    small
                                    outlined
                                    dark
                                    color="orange accent-3"
                                >
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'Descargar plantilla'
                                    }}
                                    <v-icon rigth>mdi-arrow-down</v-icon>
                                </v-btn>
                            </div>
                            <div>
                                <v-btn
                                    @click="files = []"
                                    class="vcard-text-sm"
                                    small
                                    outlined
                                    dark
                                    color="red darken-2"
                                >
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'borrar'
                                    }}
                                    <v-icon rigth>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-divider class="test"></v-divider>
            <UploadForm
                class="pt-4"
                :message="message"
                :action="uploadAction"
                :multiple="multiple"
            />
            <v-card-actions class="justify-end">
                <v-col cols="12" md="4" class="ml-auto">
                    <div
                        :class="
                            $vuetify.breakpoint.smAndDown
                                ? 'd-block'
                                : 'd-flex justify-end'
                        "
                    >
                        <v-btn
                            depressed
                            :width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
                            :class="$vuetify.breakpoint.smAndDown ? 'mb-1' : ''"
                            color="success"
                            dark
                            :disabled="isExporting"
                            @click="submit"
                        >
                            <v-icon left> mdi-content-save </v-icon>
                            guardar
                        </v-btn>
                        <v-btn
                            depressed
                            text
                            color="red"
                            :width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
                            :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
                            @click="
                                isOpenDialog = false;
                                files = [];"
                        >
                            cerrar
                        </v-btn>
                    </div>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import UploadForm from '@/components/UploadForm/UploadForm.vue';

export default {
    name: 'DownloadTemplateAndUpload',
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        message: '',
        uploadMessage: '',

        title: '',
        templateMutationPath: '',
        templatePath: '',

        submitMutationPath: '',
        submitPath: '',

        datePicker: '',
        uploadParam: null,
    },
    components: {
        UploadForm,
    },
    data: () => ({
        uploadAction: '',
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
    }),
    computed: {
        isExporting() {
            return this.$store.state.util.isExporting;
        },
        isOpenDialog: {
            set(val) {
                this.$store.commit('util/isOpenDownloadTemplateAndUpload', val);
            },
            get() {
                return this.$store.state.util.isOpenDownloadTemplateAndUpload;
            },
        },
        files: {
            set(val) {
                this.$store.commit('gerencia/files', val);
            },
            get() {
                return this.$store.state.gerencia.files;
            },
        },
    },
    methods: {
        async download_template() {
            this.uploadAction = 'Descargando';
            if (this.templatePath) {
                const module = await import('/src/util/' + this.templatePath);
                this.$store.dispatch(this.templateMutationPath, module.default);
            } else this.$store.dispatch(this.templateMutationPath);
        },
        submit() {
            this.uploadAction = 'Subiendo';
            if (this.datePicker) {
                let params = {
                    task_to_do: this.submitPath,
                    task_params: {
                        date: this.date,
                    },
                };

                this.$store
                    .dispatch(this.submitMutationPath, params)
                    .then((res) => {
                        this.$emit('submitted', this.submitMutationPath);
                    });
            } else if (this.uploadParam) {
                let params = {
                    task_to_do: this.submitPath,
                    task_params: {
                        uploadParam: this.uploadParam,
                    },
                };

                this.$store
                    .dispatch(this.submitMutationPath, params)
                    .then((res) => {
                        this.$emit('submitted', this.submitMutationPath);
                    });
            } else {
                let params = {
                    task_to_do: this.submitPath,
                };

                this.$store
                    .dispatch(this.submitMutationPath, params)
                    .then((res) => {
                        this.$emit('submitted', this.submitMutationPath);
                    });
            }
        },
    },
};
</script>

<style>
.vcard-text {
    font-size: 30px;
    font-family: 'Roboto Condensed', sans-serif;
}
</style>